import { ItemWithId } from 'components/table/types';
import { PropsWithChildren } from 'react';
import { HeaderProps } from 'react-table';

type Props<T extends ItemWithId> = {
  className?: string;
  title?: string;
  tableProps: PropsWithChildren<HeaderProps<T>>;
};
const StandardHeader = <T extends ItemWithId>({ className, title, tableProps }: Props<T>) => {
  return (
    <th {...tableProps.column.getHeaderProps()} className={className}>
      <span dangerouslySetInnerHTML={{ __html: title ?? '' }} />
    </th>
  );
};

export { StandardHeader };
